import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import _get from 'lodash/get';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import getInventoryAction from '../../../actions/BundleInventoryAction';
import BundleChildDetails from './BundleChildDetails';
import * as styles from './BundleChildDetails.css';

const cx = classNames.bind(styles);

export class BundleCollectionDetails extends Component {
    static propTypes = {
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
    };

    static defaultProps = {
        productDetails: {},
        selectedStore: {},
        featureFlags: {},
    };

    componentDidMount() {
        const { productDetails } = this.props;
        /* istanbul ignore else */
        if (productDetails.id) {
            const storeID = '';
            const inventoryPayload = {
                PPID: productDetails.id,
                storeID,
            };
            inventoryPayload.url = _get(productDetails, 'additionalDetails.url', '');
            this.props.actions.getInventoryAction(inventoryPayload);
        }
    }

    bundleProductdetails(bundleProductDetails) {
        return (
            bundleProductDetails &&
            bundleProductDetails.map((product, index) => {
                const BundleProduct = (
                    <BundleChildDetails bundleChildDetails={product} index={index} />
                );
                return <div id={`bundleChild-${index}`}>{BundleProduct}</div>;
            })
        );
    }

    render() {
        const { productDetails } = this.props;
        /* istanbul ignore next */
        return (
            <section
                className={`${dt([
                    'border-t',
                    'border-solid',
                    'border-gray-25',
                    'mt-10',
                    'smMd:pt-4',
                ])} ${cx('explorerPackageContainer')}`}
                data-automation-id="bundleParent"
            >
                {productDetails && productDetails.products
                    ? this.bundleProductdetails(productDetails.products)
                    : ''}
            </section>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ getInventoryAction }, dispatch),
});

export default connect(null, mapDispatchToProps)(BundleCollectionDetails);
